'use strict';
import isNumber from 'lodash/isNumber';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import {SyncStatus} from '../../_libs/redux-observable-list';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {firebaseAuthSuccess} from '../../auth/actions';
import {markCommentsRead} from '../actions';

/**
 * @typedef {Object} ChatMessagesListSupportEpicsOptions
 * @property {ReduxObservableListActions} actions
 * @property {Function} getState
 * @property {bunyan} logger
 */

/**
 * @param {ChatMessagesListSupportEpicsOptions} options
 */
export function buildListSupportEpics(options) {
  const actions = options.actions;
  const logger = options.logger;
  const getState = options.getState;

  onInitListGetMetrics.$inject = [
    'UserDomain',
  ];

  return [
    onInitListGetMetrics,
    onPostMessageSuccess,
  ];

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param {Object} dependencies
   * @return {Observable.<ReduxAction>}
   */
  function onInitListGetMetrics(action$, store, dependencies) {
    return action$.ofType(firebaseAuthSuccess.TYPE)
      .map(action => action.payload.userId)
      .switchMap(userId =>
        action$.ofType(actions.initList.TYPE)
          .switchMap(action =>
            dependencies.UserDomain.getCommentzReadCountRef(userId, action.payload.parentId).observe('value')
              .map(ss => ss.exists() ? ss.val() : null)
              .distinctUntilChanged()
              .map(readCount => actions.updateReadCount({readCount}, {parentId: action.payload.parentId}))
              .takeUntil(action$.ofType(actions.destroyList.TYPE)
                .filter(destroyAction => destroyAction.meta.parentId === action.payload.parentId)
              )
          )
      )
      .catch(epicErrorHandler(logger, 'onInitListGetMetrics'));
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @return {Observable<any>}
   */
  function onPostMessageSuccess(action$, store) {
    return action$.ofType(actions.postTextMessage.TYPE)
      .mergeMap(postAction =>
        action$.ofType(actions.updateSyncStatus.TYPE)
          .filter(action => actionMatchesMessage(postAction, action))
          .take(1)
          .map(() => {
            const state = getState(store.getState());
            const total = state.total;

            return markCommentsRead(postAction.payload.channel, isNumber(total) ? total + 1 : 1);
          })
          .takeUntil(action$.ofType(actions.destroyList.TYPE)
            .filter(destroyAction => destroyAction.meta.parentId === postAction.payload.channel)
          )
      )
      .catch(epicErrorHandler(logger, 'onPostMessageSuccess'));
  }

  function actionMatchesMessage(postAction, action) {
    return postAction.payload.requestId === action.payload.requestId
      && action.payload.syncStatus === SyncStatus.SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/epics/listSupportEpics.js